import type { RosterFilters } from './types';

export const DEFAULT_ARTIST_FILTERS: RosterFilters = {
  labels: [],
  isCrossover: false,
  isOnRoster: undefined,
};
